<div (focusout)="onBlur()">
  <app-search-box
    placeholder="Buscar leads, clientes, presupuestos, proyectos, facturas…"
    variant="global"
    (valueChange)="onSearch($event)"
  />

  @if (open() && groups().length > 0) {
    <div
      class="absolute top-full left-0 z-20 mt-1 max-h-96 w-full min-w-80 overflow-y-auto rounded-md border border-default bg-surface shadow-lg"
    >
      @for (group of groups(); track group.label) {
        <div class="border-b border-default px-3 py-1.5 text-caption font-medium text-tertiary">
          {{ group.label }}
        </div>
        @for (item of group.items; track item.entityId) {
          <button
            type="button"
            class="flex w-full flex-col items-start gap-0.5 px-3 py-2 text-left hover:bg-surface-hover"
            (click)="select(item)"
          >
            <span class="text-body text-primary">{{ item.title }}</span>
            @if (item.subtitle) {
              <span class="text-caption text-tertiary">{{ item.subtitle }}</span>
            }
          </button>
        }
      }
    </div>
  }
</div>
